import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Button,
  Text
} from '@chakra-ui/react'
import {
  getEditProfileMessage,
  setIsChangesSaved,
  setIsProfileIncomplete,
  setUserSectionPage,
  usersSelectors
} from 'store'
import {
  EDIT_PROFILE,
  PLATFORM_LIST
} from 'utils/constants'

export const DiscardChanges = ({
  isDiscard,
  setIsDiscard,
  isClickedOutside
}) => {
  const {
    isProfileIncomplete,
    userSectionPage
  } = useSelector(usersSelectors)
  const [isIncomplete, setIsIncomplete] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const dispatch = useDispatch()

  const handleDiscardChanges = () => {
    if (isProfileIncomplete === true) {
      setIsIncomplete(true)
    } else {
      dispatch(getEditProfileMessage({
        message1: [],
        message2: []
      }))
      setIsDiscard(false)
      dispatch(setIsProfileIncomplete(false))
      dispatch(setIsChangesSaved(true))
      setIsOpen(false)
    }
  }

  const handleIncompleteChanges = () => {
    setIsDiscard(false)
    setIsIncomplete(false)
    setIsOpen(false)
  }

  const handleCloseDiscard = () => {
    setIsDiscard(false)
    dispatch(setIsProfileIncomplete(false))
    dispatch(getEditProfileMessage({
      message1: [],
      message2: []
    }))

    if (isClickedOutside === true) {
      dispatch(setUserSectionPage('clear'))
    } else {
      dispatch(setUserSectionPage(null))
    }

    setIsOpen(false)
  }

  const handleCloseButtonDiscard = () => {
    setIsDiscard(false)
    setIsOpen(false)
  }

  useEffect(() => {
    if (isDiscard === true) {
      setIsOpen(true)
    }
  }, [isDiscard])

  useEffect(() => {
    if (!isOpen) return () => {}

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleCloseButtonDiscard()
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [isOpen, dispatch])

  return isOpen && (
    <>
      <Box
        position="fixed"
        top={0}
        left={0}
        width="100vw"
        height="100vh"
        bg="blackAlpha.600"
        zIndex={1413}
        onClick={handleCloseButtonDiscard}
      />

      <Box
        position="fixed"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="100vw"
        maxWidth="450px"
        height="auto"
        maxHeight="500px"
        overflow="hidden"
        bg="white"
        borderRadius="md"
        boxShadow="lg"
        zIndex={1413}
        display="flex"
        flexDirection="column"
        onClick={(e) => e.stopPropagation()}
      >
        <Box
          px={6}
          py={4}
          fontSize="xl"
          fontWeight="bold"
        >
          Save Changes
        </Box>

        <Box
          as="button"
          name="close-location-modal"
          position="absolute"
          top={1}
          right={3}
          fontSize="md"
          p={2}
          onClick={handleCloseButtonDiscard}
        >
          ✕
        </Box>

        <Box
          flex="1"
          px={6}
          pt={2}
          pb={2}
          overflowY="auto"
        >
          {
            isIncomplete === true
              ? <Text>Your profile is incomplete</Text>
              : <Text>Are you sure you want to save your changes?</Text>
          }
        </Box>

        <Box
          px={6}
          py={4}
          display="flex"
          justifyContent="flex-end"
        >
          {
            isIncomplete === true
              ? (
                <Button
                  colorScheme="yellow"
                  name="reset-yes"
                  onClick={() => handleIncompleteChanges()}
                >
                  Ok
                </Button>
              ) : (
                <>
                  <Button
                    colorScheme="yellow"
                    name="reset-yes"
                    mr={3}
                    onClick={() => {
                      const drawerContents = document.querySelector(`#${EDIT_PROFILE}-drawer-body`)
                      if (drawerContents) {
                        drawerContents.scrollTop = drawerContents.scrollHeight
                      }

                      if (userSectionPage.at(-1) === PLATFORM_LIST) {
                        dispatch(setUserSectionPage(null))
                      }

                      handleDiscardChanges()
                    }}
                  >
                    Yes
                  </Button>

                  <Button
                    onClick={() => handleCloseDiscard()}
                    name="reset-no"
                  >
                    No
                  </Button>
                </>
              )
          }
        </Box>
      </Box>
    </>
  )
}
